import "./style.css";

import { useState } from "react";

import { Add, Delete, Edit, PlusOne } from "@mui/icons-material";
import { Box, Button, IconButton, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";

import OkTable from "components/OkTable";
import FormDialog from "components/dialog/FormDialog";
import { PField, useFieldValue } from "components/form/input/NestedField";
import { fieldHasError, requiredValidator } from "components/form/input/validator";

import KmlImport from "../KmlImport";
import PainelTalhaoForm from "../PainelTalhaoForm";

import { generateUid } from "functions/generateUid";

export default function TabelaTalhoes({ areaCultivada }) {
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [talhoes, setTalhoes] = useFieldValue("talhoesFazenda");
    const [talhaoEdit, setTalhaoEdit] = useState(null);

    // evita NaN quando importa um talhão sem área calculada
    if (talhoes) {
        talhoes.forEach((talhao) => {
            if (!talhao.area) {
                talhao.area = 0;
            }
        });
    }

    const updateTalhao = (talhao) => {
        let newArray = (talhoes || []).slice();
        let indexOf = talhao.index;
        if (indexOf === undefined) {
            talhao.index = 0;
            newArray.push(talhao);
        } else {
            newArray[indexOf] = talhao;
        }
        setTalhoes(newArray);
    };

    const deleteTalhao = (talhao) => {
        if (talhao.index !== undefined) {
            let newArray = (talhoes || []).slice();
            newArray.splice(talhao.index, 1);
            setTalhoes(newArray);
        }
    };

    const startNew = () => {
        let t = { uid: generateUid() };
        let indexAux = 1;
        while ((talhoes || []).map((t) => t.nome).includes("TH" + indexAux)) {
            indexAux++;
        }
        t.nome = "TH" + indexAux;
        setTalhaoEdit(t);
    };

    return (
        <PField style={{ borderStyle: "dotted" }} name={"talhoesFazenda"} validate={requiredValidator}>
            {(fieldProps) => {
                const hasError = fieldHasError(fieldProps.meta);
                return (
                    <Box sx={{ flex: 1 }}>
                        <Box sx={{ display: "flex", paddingY: 1, gap: 2, alignItems: "center" }}>
                            <Typography style={{ flex: 1 }}>Talhões</Typography>
                            {hasError && <Typography sx={{ color: "#f00" }}>{fieldProps.meta.error}</Typography>}
                            <KmlImport talhoes={talhoes} setTalhoes={setTalhoes} />
                            <Button sx={{ width: "fit-content" }} onClick={startNew}>
                                {mobile ? <Add /> : "Adicionar Talhão"}
                            </Button>
                        </Box>
                        <OkTable
                            mobile
                            columns={[
                                { name: "Nome", field: "nome", displayHidden: mobile && true },
                                { name: "Área", field: "area", displayHidden: mobile && true },
                                { name: "Variedade", field: "variedade.variedade", displayHidden: mobile && true },
                                {
                                    cell: (t, i) => {
                                        return (
                                            <Box
                                                sx={{ width: "100%", justifyContent: "space-between" }}
                                                style={{ display: "flex" }}
                                            >
                                                {mobile && (
                                                    <Box sx={{ display: "flex", gap: 2, flex: 1 }}>
                                                        <TextField
                                                            sx={{ width: "100%" }}
                                                            variant="standard"
                                                            disabled
                                                            value={t.nome}
                                                            label="Nome"
                                                        />
                                                        <TextField
                                                            variant="standard"
                                                            disabled
                                                            value={t.area}
                                                            label="Área"
                                                        />
                                                    </Box>
                                                )}
                                                <IconButton onClick={() => setTalhaoEdit({ ...t, index: i })}>
                                                    <Edit />
                                                </IconButton>

                                                <IconButton onClick={() => deleteTalhao({ ...t, index: i })}>
                                                    <Delete />
                                                </IconButton>
                                            </Box>
                                        );
                                    },
                                    width: "110px",
                                },
                            ]}
                            data={talhoes}
                        />

                        {talhaoEdit && (
                            <FormDialog
                                height="90%"
                                title={"Talhão"}
                                onClose={() => {
                                    setTalhaoEdit(undefined);
                                }}
                                open={talhaoEdit ? true : false}
                                value={talhaoEdit}
                                validValues={async (v) => {
                                    let errorsMessage = [];

                                    for (let index = 0; index < talhoes.length; index++) {
                                        const t = talhoes[index];
                                        if (v.index !== index) {
                                            if (v.nome === t.nome) {
                                                errorsMessage.push("Nome de talhão já utilizado");
                                            }
                                        }
                                    }
                                    if (errorsMessage.length) {
                                        return errorsMessage;
                                    }
                                    return null;
                                }}
                                updateValue={(values) => {
                                    updateTalhao(values);
                                    setTalhaoEdit(undefined);
                                }}
                            >
                                {(formProps) => <PainelTalhaoForm areaCultivada={areaCultivada} {...formProps} />}
                            </FormDialog>
                        )}
                    </Box>
                );
            }}
        </PField>
    );
}
